import surveyAPI from 'api/base';

import { GetPayment, PostPaymentInfo } from './types';

export const getPayment: GetPayment = (uuid, paymentId) => {
  return surveyAPI.get(`/payments/${uuid}?payment_id=${paymentId}`);
};

export const postPaymentInfo: PostPaymentInfo = (data) => {
  return surveyAPI.post(`surveys:payment_info/?use_mess=true`, data);
};
